import { atom } from 'recoil';
import defaultProjects from 'ProjectManager/Project/List/recoil/projects/defaultProjects';

const projectsAtom = atom({
    key: 'projectManagement_projectsList',
    default: defaultProjects,
});

export default projectsAtom;
